<div class="bg-img-circule-login">
    <img src="../../../../../assets/images/Login-2.png" />
</div>
<app-menu-template1>
    <main class="container pb-5 d-flex align-items-stretch">
        <article class="row mb-5">
            <aside class="col-md-6">
                <header>
                    <label class="vista-seguridad-titulo-width text-white mb-4 h1">Registro Nacional de Turismo (RNT)</label>
                    <p class="vista-seguridad-titulo-width text-white mb-4">Registro público, en el cual deben
                        inscribirse todos
                        los prestadores de servicios turísticos que
                        efectúen sus operaciones en Colombia.</p>
                </header>
            </aside>
            <section class="col-md-6">
                <ng-content></ng-content>
            </section>
        </article>
    </main>
</app-menu-template1>
